import { createContext, useContext } from 'react';

export const ReportIssueContext = createContext({
  setReportIssueContext: () => {},
});

export function useReportIssueContext() {
  return useContext(ReportIssueContext);
}
